__turbopack_context__.v({
  "backgroundText": "interactive-features-module-scss-module__DPzaja__backgroundText",
  "interactiveFeature": "interactive-features-module-scss-module__DPzaja__interactiveFeature",
  "interactiveFeaturesContainer": "interactive-features-module-scss-module__DPzaja__interactiveFeaturesContainer",
  "learningSection": "interactive-features-module-scss-module__DPzaja__learningSection",
  "marqueeContent": "interactive-features-module-scss-module__DPzaja__marqueeContent",
  "marqueeText": "interactive-features-module-scss-module__DPzaja__marqueeText",
  "marqueeTextItem": "interactive-features-module-scss-module__DPzaja__marqueeTextItem",
  "sectionSubtitle": "interactive-features-module-scss-module__DPzaja__sectionSubtitle",
  "sectionTitle": "interactive-features-module-scss-module__DPzaja__sectionTitle",
  "sectionTitleContainer": "interactive-features-module-scss-module__DPzaja__sectionTitleContainer",
});
